module.exports = __webpack_public_path__ + "img/btx.c970685f.svg";